export default "__VITE_ASSET__C8ZjGw0$__"